import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

import lazyload from './features/lazy-load';
import proportionalScroll from './features/proportional-scroll';

lazyload();
proportionalScroll();


initMain([], {
    JournalistsAc: () => import('./vue/components/journalists-ac/JournalistsAc.vue'),
    AnalysisSectionPager: () => import('./vue/components/analysis-section-pager/AnalysisSectionPager.vue')
}, []);
header();